import { apiRequest } from "../util/apiUtils";

export const categoryList = async (params) => {
  try {
    const res = await apiRequest("get", `taxonomy/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const categoryDetails = async (params) => {
  try {
    const res = await apiRequest("get", `taxonomy/detail/${params?.id}`, {});

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const categoryAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `taxonomy/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const categoryDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `taxonomy/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const categoryStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `taxonomy/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const categoryOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `taxonomy/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
